import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { CalendarDays, ArrowUpRight, Route, Utensils, FileText } from "lucide-react";
import poster from "@/assets/san-silvestre-sierra-norte-definitivo.jpg.asset.json";
import reglamento from "@/assets/reglamento-san-silvestre-2026.pdf.asset.json";
import { CarreraBeneficios } from "@/components/eventos/CarreraBeneficios";
import { euro, fechaEvento, type EventoCarrera } from "@/lib/carrera.shared";
export function CarreraPromocion({ evento }: { evento: EventoCarrera }) {
  return (
    <section className="border-b border-border bg-secondary/35">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 py-12 md:grid-cols-[1fr_320px] md:px-6 md:py-16">
        <div>
          <p className="mb-4 text-sm font-medium text-accent">{fechaEvento(evento.fecha)} · PRIMERA EDICIÓN</p>
          <h2 className="max-w-xl font-serif text-3xl leading-tight text-primary md:text-4xl">
            {evento.titulo}
          </h2>
          <p className="mt-4 max-w-xl text-muted-foreground">{evento.recorrido}</p>
          <div className="my-6 flex flex-wrap gap-x-6 gap-y-3 text-sm">
            <span className="flex items-center gap-2">
              <CalendarDays size={18} />
              {fechaEvento(evento.fecha)} · {evento.salida} h
            </span>
            <span className="flex items-center gap-2">
              <Route size={18} />
              {evento.distancia_km} km
            </span>
            <span className="flex items-center gap-2">
              <Utensils size={18} />
              Comida incluida
            </span>
          </div>
          <p className="mb-6 text-sm">
            Corredores y andarines <strong>{euro(Number(evento.precio_participante))}</strong>
            <span className="mx-3 text-border">/</span>Acompañantes{" "}
            <strong>{euro(Number(evento.precio_acompanante))}</strong>
          </p>
          <div className="mb-6 max-w-xl"><CarreraBeneficios /></div>
          <Button asChild size="lg">
            <Link to="/san-silvestre-sierra-norte">
              Inscribirme <ArrowUpRight />
            </Link>
          </Button>
        </div>
        <div className="mx-auto w-full max-w-[320px]">
          <Link to="/san-silvestre-sierra-norte" className="block">
            <img
              src={poster.url}
              alt="Cartel de la I San Silvestre de la Sierra Norte"
              width={1024}
              height={1536}
              loading="lazy"
              className="h-auto w-full rounded-sm"
            />
          </Link>
          <a
            href={reglamento.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 flex items-center justify-center gap-2 text-sm font-medium text-primary underline-offset-4 hover:underline"
          >
            <FileText size={16} /> Ver reglamento (PDF)
          </a>
        </div>
      </div>
    </section>
  );
}
